// Sugalarm — kiosk detection selector (cycle 173).
//
// Derives "does this account have a LIVE paired kiosk?" from the device
// list the app already loads (`GET /api/devices`) — true iff a row has
// device_type === "kiosk" AND no revoked token. Read-only over the
// caller's own authenticated devices; this is a UX gate, not a security
// control (the server stays authoritative on every settings PATCH and the
// JWT-only device guards are unchanged). Caller treats the not-yet-loaded
// state as "no kiosk" → fail-safe LOCKED.

import type { Device } from "./types";

export function selectHasPairedKiosk(devices: Device[]): boolean {
  return devices.some(
    (d) => d.device_type === "kiosk" && d.token_revoked_at == null,
  );
}

/** Cycle 471 — the number the Settings header shows: ACTIVE rows (the
 *  server's derived `active`, the same predicate the sweep keeps and the
 *  admin roster counts), not every row ever registered. A missing flag (an
 *  older server) reads as active, matching the "Show inactive" split. */
export function countActiveDevices(devices: Device[]): number {
  return devices.filter((d) => d.active !== false).length;
}
